import { render, staticRenderFns } from "./2faSelect.vue?vue&type=template&id=b33050bc&scoped=true&"
import script from "./2faSelect.vue?vue&type=script&lang=js&"
export * from "./2faSelect.vue?vue&type=script&lang=js&"
import style0 from "./2faSelect.vue?vue&type=style&index=0&id=b33050bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33050bc",
  null
  
)

export default component.exports